<template>
  <footer class="site-footer">
    <div class="shell footer-inner">
      <div class="footer-brand">
        <img :src="brand.icon" alt="Centerfire Services icon" />
        <div>
          <h3>{{ brand.name }}</h3>
          <p>{{ brand.tagline }}</p>
        </div>
      </div>

      <nav class="footer-links" aria-label="Footer">
        <router-link to="/">Home</router-link>
        <router-link to="/blog">Blog</router-link>
        <router-link to="/maintunits">Maintained Units</router-link>
        <router-link to="/services-request">Service Request</router-link>
        <a :href="`${adminOrigin}/login`">Staff sign in</a>
        <router-link to="/privacy">Privacy</router-link>
        <router-link to="/terms">Terms</router-link>
      </nav>

      <p class="copyright">{{ brand.copyright }}</p>
    </div>
  </footer>
</template>

<script>
import { adminOrigin } from '@/data/siteOrigins';
import { brand } from '@/data/content';

export default {
  data() {
    return { brand, adminOrigin };
  },
};
</script>

<style scoped>
.site-footer {
  border-top: 1px solid var(--orange);
  background: var(--black);
  margin-top: 84px;
}

.footer-inner {
  padding: 2.3rem 0;
  display: grid;
  gap: 1rem;
}

.footer-brand {
  display: flex;
  gap: 0.8rem;
  align-items: center;
}

.footer-brand img {
  width: 48px;
  height: 48px;
}

.footer-brand h3 {
  font-size: 1.08rem;
}

.footer-brand p {
  color: var(--white);
  font-size: 0.92rem;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  color: var(--white);
  font-weight: 600;
}

.footer-links a:hover,
.footer-links a.router-link-active {
  color: var(--orange);
}

.copyright {
  color: var(--white);
  font-size: 0.9rem;
}
</style>
